import React from "react";
import OverviewBusiness from "../components/OurBussiness/Overview.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const Business = () => {
  return (
    <div>
      <MetaComponent
        title="Vocational Training and Institutional Businesses | Aptech Limited"
        desc="Aptech limited offers top-tier vocational training in IT, animation, VFX, aviation, and more to transform careers and education for individuals and organizations worldwide. "
        keywords="vocational training, skill training, enterprise business, institutional business, Aptech limited"
      />
      <OverviewBusiness />
    </div>
  );
};

export default Business;
